import React from 'react'

import { ReactComponent as PetIcon } from '../../../../../assets/icons/pet-alt-vet.svg'

import BaseModal from '../BaseModal'
import NewPetForm from './NewPetForm'

const NewPetModal = ({ tutorData = undefined, petData = undefined, visibility = false, setVisibility = undefined, updated, alert = undefined }) => {
  return (
    <BaseModal
      visibility={visibility}
      setVisibility={setVisibility}
      icon={<PetIcon />}
      title={
        petData
          ? 'Edição dos dados do pet'
          : 'Novo Pet'
      }
      subTitle={
        petData
          ? 'Ao editar os dados e salvar, as informações do pet serão atualizadas automaticamente.'
          : 'Cadastre um novo pet vinculado a este tutor. O prontuário será criado automaticamente.'
      }
    >
      <NewPetForm visibility={visibility} setVisibility={setVisibility} petData={petData} updated={updated} tutorData={tutorData} alert={alert}/>
    </BaseModal>
  )
}

export default NewPetModal
